<template>
  <div class="modal fade" id="addNewBudget" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    role="dialog" aria-labelledby="addNewBudgetLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-if="show">
        <div class="modal-header shadow-sm">
          <h6 class="modal-title font-weight-bold" id="addNewBudgetLabel">
            <p class="mb-1">{{ editingBudget ? "Edit" : "Add New" }} Budget</p>
          </h6>
        </div>
        <div class="modal-body">
          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="year">
                  Year<sup class="text-danger">*</sup>
                </label>
                <div class="row">
                  <div class="col px-2">
                    <input type="number" step="1" min="0" class="form-control form-control-sm" id="kjp"
                      placeholder="Enter year" v-model="models.year" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label class="small mb-1">
                  District<sup class="text-danger">*</sup>
                </label>
                <div class="dropdown rounded w-100">
                  <button
                    class="w-100 btn btn-sm btn-block bg-white dropdown-toggle position-relative d-flex justify-content-between align-items-center px-3"
                    style="font-size: 0.875rem; color: #495057" type="button" id="dropdownDistrictButton"
                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span v-if="models.district">
                      {{ districtName(models.district) }}
                    </span>
                    <span v-else class="text-muted">-- Select district</span>
                  </button>
                  <div class="dropdown-menu py-0 w-100 shadow-sm p-0" aria-labelledby="dropdownDistrictButton"
                    style="height: 200px; overflow: hidden; font-size: 0.875rem">
                    <input class="form-control form-control-sm" placeholder="Search" v-model="districtSearchModel" />
                    <div style="height: calc(100% - 43px); overflow-y: auto">
                      <button v-for="district in computedDistricts" :key="`select-district-${district.id}`"
                        class="border-bottom dropdown-item px-3 py-2" :class="{
                          'bg-subtle': models.district == district.id,
                        }" style="color: #495057" @click="districtSelected(district.id)">
                        {{ district.name }}
                        <i class="fas fa-check text-primary ml-2 small" v-if="models.district == district.id" />
                      </button>
                      <div class="dropdown-item py-2 small text-center text-muted font-italic px-3 py-2 fs-8">
                        <span v-if="computedDistricts.length > 0">
                          End of list
                        </span>
                        <span v-else>No district found</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="kjp">
                  NOD
                </label>
                <div class="row">
                  <div class="col px-2">
                    <div class="input-group">
                      <span class="input-group-text">RM</span>
                      <input type="number" step="1" min="0" class="form-control text-end" id="kjp"
                        placeholder="Enter amount" v-model="models.kjp" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="emergency">
                  Emergency
                </label>
                <div class="row">
                  <div class="col px-2">
                    <div class="input-group">
                      <span class="input-group-text">RM</span>
                      <input type="number" step="1" min="0" class="form-control text-end" id="emergency"
                        placeholder="Enter amount" v-model="models.emergency" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-0 mb-3">
            <div class="col">
              <div class="form-group">
                <label class="small mb-1" for="electrical">
                  Electrical
                </label>
                <div class="row">
                  <div class="col px-2">
                    <div class="input-group">
                      <span class="input-group-text">RM</span>
                      <input type="number" step="1" min="0" class="form-control text-end" id="electrical"
                        placeholder="Enter amount" v-model="models.electrical" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer shadow">
          <button type="button" class="btn btn-link btn-sm" @click="closeModal()">
            Cancel
          </button>
          <button type="button" class="btn btn-sm btn-primary" @click="saveChanges()" :disabled="isProcessing">
            <div class="spinner-border spinner-border-sm text-light" v-if="isProcessing"></div>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap/dist/js/bootstrap.esm.min";
import Swal from "sweetalert2";

export default {
  name: "add-new-budget-modal",
  props: ["show", "selectedYear", "editingBudget", "districts"],
  data() {
    return {
      modal: null,
      isProcessing: false,
      districtSearchModel: null,
      models: {
        district: null,
        year: this.Helper.currentYear,
        kjp: 0,
        emergency: 0,
        electrical: 0
      },
      emptyModels: {
        district: null,
        year: this.Helper.currentYear,
        kjp: 0,
        emergency: 0,
        electrical: 0
      },
    };
  },
  watch: {
    isProcessing: {
      handler() {
        this.Helper.toggleLoadingSpinner(this.isProcessing);
      },
      deep: true,
      immediate: true,
    },
    show: {
      async handler() {
        if (this.modal && this.show) {
          this.models = JSON.parse(JSON.stringify(this.emptyModels));

          if (this.selectedYear) {
            this.models.year = this.selectedYear;
          }

          this.modal.show();

          if (this.editingBudget) {
            Object.keys(this.models).forEach(key => {
              if (key == "district") {
                this.models[key] = this.editingBudget[key]?.id;
              } else {
                this.models[key] = this.editingBudget[key];
              }
            });
          }
        } else if (this.modal) {
          this.modal.hide();

          this.districtSearchModel = null;

          this.models = JSON.parse(JSON.stringify(this.emptyModels));
        }
      },
      immediate: true,
    },
    "models.district": {
      async handler() {
        if (this.models.district) {
          this.districtSearchModel = null;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    computedDistricts() {
      let list = JSON.parse(JSON.stringify(this.districts));

      if (this.districtSearchModel) {
        list = list.filter((l) =>
          l.name.toLowerCase().includes(this.districtSearchModel.toLowerCase())
        );
      }

      return list;
    },
    districtName() {
      return (id) => this.districts.find((district) => district.id == id)?.name;
    },
  },
  methods: {
    districtSelected(id) {
      this.models.district = id;
    },
    formatDate(timestamp, withTime) {
      return this.Helper.formatDate(timestamp, withTime);
    },
    closeModal(response) {
      if (!this.isProcessing) {
        this.$emit("close", response);
      }
    },
    async saveChanges() {
      if (!this.models.year || !this.models.district) return;

      this.isProcessing = true;

      const body = { ...this.models };

      try {
        let method = "post";
        let url = "nod-budgets";

        if (this.editingBudget) {
          method = "put";
          url += `/${this.editingBudget.id}`
        }

        await this.API[method](url, body);

        this.isProcessing = false;

        Swal.fire(this.editingBudget ? "Budget updated" : "New budget added", "", "success");

        this.closeModal(true);
      } catch (error) {
        console.error(error);

        Swal.fire("Error creating budget", "", "error");
      }

      this.isProcessing = false;
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById("addNewBudget"));
  },
};
</script>